export default __webpack_public_path__ + "static/media/What-is-Wix-eCommerce.f07d6f85.png";